<app-header></app-header>
<div class="eps-container container-fluid">
  <app-animated-loader
    *ngIf="isLoading"
    class="animated fadeIn"
  ></app-animated-loader>
  <div></div>
  <div *ngIf="!isLoading" class="card animated fadeIn my-2">
    <div class="card-body">
      <app-metabase-dashboard></app-metabase-dashboard>
    </div>
  </div>
</div>
